//对axios二次封装
import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
import * as auth from "@/utils/auth";
//引入进度条
import nprogress from "nprogress";
import "nprogress/nprogress.css";

//创建axios实例
const request = axios.create({
  // 读取环境变量的baseURL
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    "access-token": localStorage.getItem("token") || "",
  },
});
//请求拦截器
request.interceptors.request.use((config) => {
  if (auth.isLoginExpired()) {
    auth.removeAdminInfo();
    Message.warning("登录已超时，请重新登录");
    router.replace({ path: "/Login" });
    return Promise.reject(new Error("登录已超时"));
  }

  if (config.url && config.url.indexOf("/WebLogin") === -1) {
    nprogress.start();
  }

  const admin = auth.getAdminInfo();
  if (admin) {
    config.headers["access-token"] = localStorage.getItem("token") || "";
  } else {
    config.headers["access-token"] = "";
  }
  // automatically pull any query-string parameters off of the URL
  // and merge them into `params` for GET or `data` for other methods.
  // this allows the callers in api/index.js to stop concatenating
  // values onto the URL and simply rely on the axios body/params.
  if (config.url) {
    const parts = config.url.split("?");
    if (parts.length > 1) {
      config.url = parts[0];
      const query = parts[1];
      const searchParams = new URLSearchParams(query);
      const obj = {};
      for (const [key, value] of searchParams.entries()) {
        obj[key] = value;
      }
      if (config.method && config.method.toLowerCase() === "get") {
        config.params = Object.assign({}, config.params || {}, obj);
      } else {
        config.data = Object.assign({}, config.data || {}, obj);
      }
    }
  }
  return config;
});
//响应拦截器
request.interceptors.response.use(
  (res) => {
    nprogress.done();
    return res.data;
  },
  (error) => {
    nprogress.done();
    if (error.response) {
      if (error.response.status === 401) {
        auth.removeAdminInfo();
        Message.warning("身份已失效，请重新登录");
        router.replace({ path: "/Login" });
      }
    }
    return Promise.reject(error);
  },
);
//导出
export default request;
